import { Col, Container, Row } from "react-bootstrap";
import { WhoIntegrates } from "../components/home/whointegrates/whointegrates";
import HelpHubHeading from "../components/helphub/helphubheading/helphubheading";

import Breadcrumbs from "../components/Breadcrumbs";
import HelpHubSideNav from "../components/helphub/helphubsidenav/helphubsidenav";
import HelphubInfo1 from "../components/helphub/helphubinfo/helphubinfo1";
import HelpHubSideNavMobile from "../components/helphub/helphubsidenav/helphubsidenavmobile";
import { Helmet } from "react-helmet";

const HelpHub = ({ findUser, metaTitle, metaDescription }) => {
  if (findUser) {
    return (
      <>
        <Container
          fluid={+true}
          id="helphub-wrapper"
          style={{
            backgroundColor: "var(--background-profile)",
            minHeight: "calc(100vh - 218px)",
          }}
        >
          <Helmet>
            <title>{metaTitle}</title>
            <meta name="description" content={metaDescription} />
          </Helmet>
          <Container className="content-container">
            <Row className="pt-2 justify-content-center">
              <Col className="px-0" xs="12" lg="10">
                <HelpHubHeading />
                <HelpHubSideNavMobile />
                <HelphubInfo1 />
                <WhoIntegrates />
              </Col>
              <Col id="helphub-side-nav-col" xs="12" lg="2" className="pt-2">
                <HelpHubSideNav />
              </Col>
            </Row>
          </Container>
        </Container>
      </>
    );
  } else {
    return (
      <>
        <Breadcrumbs />
        <Container
          fluid={+true}
          id="helphub-wrapper"
          style={{
            backgroundColor: "var(--background-profile)",
            minHeight: "calc(100vh - 218px)",
          }}
        >
          <Helmet>
            <title>{metaTitle}</title>
            <meta name="description" content={metaDescription} />
          </Helmet>
          <Container className="content-container">
            <Row className="justify-content-center">
              <Col className="" xs="12" lg="10">
                <HelpHubHeading />
                <HelpHubSideNavMobile />
                <HelphubInfo1 />
                <WhoIntegrates />
              </Col>
              <Col id="helphub-side-nav-col" xs="12" lg="2" className=" pt-2">
                <HelpHubSideNav />
              </Col>
            </Row>
          </Container>
        </Container>
      </>
    );
  }
};

export default HelpHub;
